import APIClient from '@/shared/http/clients/api'

const resourceName = 'associados'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=nomeAssociado,asc`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (id, data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (filter = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${filter}&page=${index}&size=${limit}`, config)
const GetByNumSisbr = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?numSisbr=${document}`, config)
const GetByDocument = (document, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}`, config)
const GetByNomeAssociado = (nomeAssociado, limit, config = {}) => APIClient.get(`${APICore}/${resourceName}/?nomeAssociado=${nomeAssociado}&size=${limit}`, config)

const GetAllInPa = (data = {}, filter, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?paId=${data}&nomeAssociado=${filter}&page=${index}&size=${limit}&sort=nomeAssociado,asc`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?size=${limit}&page=${index}`, config)
const GetAllNotInCluster = (data = {}, filter, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?paId=${data}&nomeAssociado=${filter}&notInCluster=true&page=${index}&size=${limit}&sort=nomeAssociado,asc`, data, config)
const GetAllHasNotGerenteRelacionamento = (data = {}, filter, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?hasNotGR=true&paId=${data}&nomeAssociado=${filter}&page=${index}&size=${limit}&sort=nomeAssociado,asc`, data, config)
const updateAllGerenteRelacionamento = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/setallgr/`, data, config)
const updateAllCluster = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/setallcluster/`, data, config)
const updateMassGerenteRelacionamento = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/moveallgr/`, data, config)
const GetAllWithoutManager = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/getwithoutmanager?size=${limit}&page=${index}&sort=pessoa.nome`, config)

const SearchCampanhaLista = (filter = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/campanha-lista/?${filter}&page=${index}&size=${limit}`, config)
const GetAllTipoRenda = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/getAllTipoRenda`, data, config)
const GetAllDescricaoProfissao = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/getAllDescricaoProfissao`, data, config)
const GetAllVinculoEmpregaticio = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/getAllVinculoEmpregaticio`, data, config)

const AssociateRepository = {
  GetAll,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  GetByNumSisbr,
  GetByDocument,
  GetAllInPa,
  GetAllPaging,
  GetAllNotInCluster,
  GetAllHasNotGerenteRelacionamento,
  GetByNomeAssociado,
  updateAllGerenteRelacionamento,
  updateAllCluster,
  updateMassGerenteRelacionamento,
  GetAllWithoutManager,
  SearchCampanhaLista,
  GetAllTipoRenda,
  GetAllDescricaoProfissao,
  GetAllVinculoEmpregaticio
}

export default AssociateRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/associate.js